import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[tartIconColor]',
})
export class TartIconColorDirective implements AfterViewInit, OnChanges {
  @Input() strokeColor: string;
  @Input() fillColor: string;
  @Input() hoverStrokeColor: string;
  @Input() hasHoverColor: boolean;
  private _onHover = false;

  constructor(private element: ElementRef) { }

  @HostListener('click', ['$event'])
  onClick() {
    this._onHover = this.hasHoverColor;
  }

  @HostListener('mouseover')
  onMouseOver() {
    if(this.hasHoverColor) {
      this._onHover = true;
      const hostElem = this.element.nativeElement.children[0].children[0];
      for (let i = 0; i < hostElem.children.length; i++) {
        hostElem.children[i].setAttribute('stroke', this.hoverStrokeColor);
      }
    }
  }

  @HostListener('mouseout')
  onMouseOut() {
    if(this.hasHoverColor) {
      this._onHover = false;
      const hostElem = this.element.nativeElement.children[0].children[0];
      for (let i = 0; i < hostElem.children.length; i++) {
        if (this.strokeColor) {
          hostElem.children[i].setAttribute('stroke', this.strokeColor);
        }
      }
    }
  }


  ngAfterViewInit(): void {
    this.setIconColor();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['strokeColor']?.firstChange || !changes['fillColor']?.firstChange) {
      this.setIconColor();
    }
  }

  private setIconColor(): void {
    const hostElem = this.element.nativeElement.children[0].children[0];
    for (let i = 0; i < hostElem.children.length; i++) {
      if (this.strokeColor && !this._onHover) {
        hostElem.children[i].setAttribute('stroke', this.strokeColor);
      }
      if (this.fillColor && !this._onHover) {
        hostElem.children[i].setAttribute('fill', this.fillColor);
      }
    }
  }
}
